import { rails } from '../../../rails.js';
import { getPeople, read, write } from '../sources/api.js';
// Local aliases for existing wire shapes, absent from @cobrain/admin-contract.
// apps/api/src/routes/rails-admin.ts:264,287,308 (walls), :274 (organisations),
// :428,439 (affect), :524,541,555 (routes, moves, retire); mapped in rails/admin.ts.
export type Walls = Awaited<ReturnType<typeof rails.walls>>;
export type Wall = Walls['walls'][number];
export type Routes = Awaited<ReturnType<typeof rails.routes>>;
export type Rule = Routes['routes'][number];
export type Affect = Awaited<ReturnType<typeof rails.affect>>;
export type Setting = Affect['settings'][number];
export type WallWritten = Awaited<ReturnType<typeof rails.createWall>>;
export type RuleWritten = Awaited<ReturnType<typeof rails.retireRoute>>;
export type AffectWritten = Awaited<ReturnType<typeof rails.setAffect>>;
export type Organisations = Awaited<ReturnType<typeof rails.organisations>>;
export const privacy = {
  walls: (store: string, signal?: AbortSignal) => read<Walls>(store, '/api/admin/rails/walls', signal),
  routes: (store: string, search: string, signal?: AbortSignal) => read<Routes>(store, `/api/admin/rails/routes?q=${encodeURIComponent(search)}&limit=200`, signal),
  affect: (store: string, signal?: AbortSignal) => read<Affect>(store, '/api/admin/rails/affect', signal),
  people: getPeople,
  organisations: rails.organisations,
  createWall: (store: string, body: { orgAId: string; orgBId: string; notes: string; reason: string }) => write<WallWritten>(store, '/api/admin/rails/walls', 'POST', body),
  liftWall: (store: string, id: string, reason: string) => write<WallWritten>(store, `/api/admin/rails/walls/${encodeURIComponent(id)}`, 'PATCH', { active: false, reason }),
  moves: rails.routeMoves,
  retire: (store: string, id: string, reason: string) => write<RuleWritten>(store, `/api/admin/rails/routes/${encodeURIComponent(id)}/retire`, 'POST', { reason }),
  setAffect: (store: string, id: string, body: ({ enabled: false } | { enabled: true; reportToPrincipalId: string; reviewNote: string }) & { reason: string }) => write<AffectWritten>(store, `/api/admin/rails/affect/${encodeURIComponent(id)}`, 'PUT', body),
};
